import { render, staticRenderFns } from "./OrganizationDetailsAddressAdd.vue?vue&type=template&id=018ca650&scoped=true&"
import script from "./OrganizationDetailsAddressAdd.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsAddressAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDetailsAddressAdd.vue?vue&type=style&index=0&id=018ca650&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ca650",
  null
  
)

export default component.exports